(function() {

  /*
   * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
   * Author: Jim Palmer (based on chunking idea from Dave Koelle)
   */
  var naturalSort = function(a, b) {
    var re = /(^-?[0-9]+(\.?[0-9]*)[df]?e?[0-9]?$|^0x[0-9a-f]+$|[0-9]+)/gi;
    var sre = /(^[ ]*|[ ]*$)/g;
    var dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/;
    var hre = /^0x[0-9a-f]+$/i;
    var ore = /^0/;
    var i = function(s) {
      return naturalSort.insensitive && ('' + s).toLowerCase() || '' + s;
    };
    // convert all to strings strip whitespace
    var x = i(a).replace(sre, '') || '';
    var y = i(b).replace(sre, '') || '';
    // chunk/tokenize
    var xN = x.replace(re, '\0$1\0').replace(/\0$/,'').replace(/^\0/,'').split('\0');
    var yN = y.replace(re, '\0$1\0').replace(/\0$/,'').replace(/^\0/,'').split('\0');
    // numeric, hex or date detection
    var xD = parseInt(x.match(hre)) || (xN.length != 1 && x.match(dre) && Date.parse(x));
    var yD = parseInt(y.match(hre)) || xD && y.match(dre) && Date.parse(y) || null;
    var oFxNcL;
    var oFyNcL;
    // first try and sort Hex codes or Dates
    if (yD) {
      if (xD < yD) {
        return -1;
      } else if (xD > yD) {
        return 1;
      }
    }
    // natural sorting through split numeric strings and default strings
    for (var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {
      // find floats not starting with '0', string or 0 if not defined (Clint Priest)
      oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
      oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
      // handle numeric vs string comparison - number < string - (Kyle Adams)
      if (isNaN(oFxNcL) !== isNaN(oFyNcL)) {
        return (isNaN(oFxNcL)) ? 1 : -1;
      } else if (typeof oFxNcL !== typeof oFyNcL) {
        // rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
        oFxNcL += '';
        oFyNcL += '';
      }
      if (oFxNcL < oFyNcL) {
        return -1;
      }
      if (oFxNcL > oFyNcL) {
        return 1;
      }
    }
    return 0;
  };

  // Expose naturalSort to the world
  if (typeof define === 'function' && define.amd) {
    // AMD
    window.naturalSort = naturalSort;
    define('raven', [], function() {
      return naturalSort;
    });
  } else if (typeof module === 'object') {
    // browserify
    module.exports = naturalSort;
  } else if (typeof exports === 'object') {
    // CommonJS
    exports = naturalSort;
  } else {
    // Everything else
    window.naturalSort = naturalSort;
  }

})();



//////////////////
// WEBPACK FOOTER
// ./node_modules/js-natural-sort/dist/naturalsort.js
// module id = 146
// module chunks = 1 3 5 7 8 9 10 11 12 13 14 15 16 17 18 19